/**
 * Generated by orval v6.12.1 🍺
 * Do not edit manually.
 * Platz API
 * Platz API boi
 * OpenAPI spec version: 2.0
 */
import { useQuery, useMutation } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type {
  PlatzApiError,
  UpdateLastViewedPageRequest,
  YouTubePageView,
  UpdateOpenAiChatRequest,
  ChatDetailsView,
  CreateOpenAiChatRequest,
  OpenAiChatMessageView,
  AddMessageToChatRequest,
  SaveGoogledLyricsRequest,
  CreateYoutubeSourceResponseView,
  CreateYoutubeTranscriptRequest,
  SourceBaseView,
  GetYoutubePageParams,
  TextPageView,
  GetTextPageParams,
  GoogledLyricsDetailsView,
} from ".././model";
import { customInstance } from "../../../axios";
import type { ErrorType, BodyType } from "../../../axios";

export const updateLastViewedPage = (
  sourceId: number,
  updateLastViewedPageRequest: BodyType<UpdateLastViewedPageRequest>
) => {
  return customInstance<void>({
    url: `/api/sources/${sourceId}/last-viewed-page`,
    method: "put",
    headers: { "Content-Type": "application/json" },
    data: updateLastViewedPageRequest,
  });
};

export type UpdateLastViewedPageMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLastViewedPage>>
>;
export type UpdateLastViewedPageMutationBody =
  BodyType<UpdateLastViewedPageRequest>;
export type UpdateLastViewedPageMutationError = ErrorType<PlatzApiError>;

export const useUpdateLastViewedPage = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLastViewedPage>>,
    TError,
    { sourceId: number; data: BodyType<UpdateLastViewedPageRequest> },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLastViewedPage>>,
    { sourceId: number; data: BodyType<UpdateLastViewedPageRequest> }
  > = (props) => {
    const { sourceId, data } = props ?? {};

    return updateLastViewedPage(sourceId, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof updateLastViewedPage>>,
    TError,
    { sourceId: number; data: BodyType<UpdateLastViewedPageRequest> },
    TContext
  >(mutationFn, mutationOptions);
};
export const reprocessYoutubePage = (sourceId: number, pageNb: number) => {
  return customInstance<YouTubePageView>({
    url: `/api/sources/reprocess-youtube-page/${sourceId}/${pageNb}`,
    method: "put",
  });
};

export type ReprocessYoutubePageMutationResult = NonNullable<
  Awaited<ReturnType<typeof reprocessYoutubePage>>
>;

export type ReprocessYoutubePageMutationError = ErrorType<PlatzApiError>;

export const useReprocessYoutubePage = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reprocessYoutubePage>>,
    TError,
    { sourceId: number; pageNb: number },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reprocessYoutubePage>>,
    { sourceId: number; pageNb: number }
  > = (props) => {
    const { sourceId, pageNb } = props ?? {};

    return reprocessYoutubePage(sourceId, pageNb);
  };

  return useMutation<
    Awaited<ReturnType<typeof reprocessYoutubePage>>,
    TError,
    { sourceId: number; pageNb: number },
    TContext
  >(mutationFn, mutationOptions);
};
export const updateOpenAiChat = (
  sourceId: number,
  updateOpenAiChatRequest: BodyType<UpdateOpenAiChatRequest>
) => {
  return customInstance<void>({
    url: `/api/sources/openai-chat/${sourceId}`,
    method: "put",
    headers: { "Content-Type": "application/json" },
    data: updateOpenAiChatRequest,
  });
};

export type UpdateOpenAiChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOpenAiChat>>
>;
export type UpdateOpenAiChatMutationBody = BodyType<UpdateOpenAiChatRequest>;
export type UpdateOpenAiChatMutationError = ErrorType<PlatzApiError>;

export const useUpdateOpenAiChat = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOpenAiChat>>,
    TError,
    { sourceId: number; data: BodyType<UpdateOpenAiChatRequest> },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOpenAiChat>>,
    { sourceId: number; data: BodyType<UpdateOpenAiChatRequest> }
  > = (props) => {
    const { sourceId, data } = props ?? {};

    return updateOpenAiChat(sourceId, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof updateOpenAiChat>>,
    TError,
    { sourceId: number; data: BodyType<UpdateOpenAiChatRequest> },
    TContext
  >(mutationFn, mutationOptions);
};
export const createOpenAiChat = (
  createOpenAiChatRequest: BodyType<CreateOpenAiChatRequest>
) => {
  return customInstance<ChatDetailsView>({
    url: `/api/sources/openai-chat`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: createOpenAiChatRequest,
  });
};

export type CreateOpenAiChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOpenAiChat>>
>;
export type CreateOpenAiChatMutationBody = BodyType<CreateOpenAiChatRequest>;
export type CreateOpenAiChatMutationError = ErrorType<PlatzApiError>;

export const useCreateOpenAiChat = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOpenAiChat>>,
    TError,
    { data: BodyType<CreateOpenAiChatRequest> },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOpenAiChat>>,
    { data: BodyType<CreateOpenAiChatRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createOpenAiChat(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof createOpenAiChat>>,
    TError,
    { data: BodyType<CreateOpenAiChatRequest> },
    TContext
  >(mutationFn, mutationOptions);
};
export const translateOpenAiMessage = (
  sourceId: number,
  messageIndex: number
) => {
  return customInstance<ChatDetailsView>({
    url: `/api/sources/openai-chat/${sourceId}/message/${messageIndex}/translation`,
    method: "post",
  });
};

export type TranslateOpenAiMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof translateOpenAiMessage>>
>;

export type TranslateOpenAiMessageMutationError = ErrorType<PlatzApiError>;

export const useTranslateOpenAiMessage = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof translateOpenAiMessage>>,
    TError,
    { sourceId: number; messageIndex: number },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof translateOpenAiMessage>>,
    { sourceId: number; messageIndex: number }
  > = (props) => {
    const { sourceId, messageIndex } = props ?? {};

    return translateOpenAiMessage(sourceId, messageIndex);
  };

  return useMutation<
    Awaited<ReturnType<typeof translateOpenAiMessage>>,
    TError,
    { sourceId: number; messageIndex: number },
    TContext
  >(mutationFn, mutationOptions);
};
export const addMessageToOpenAiChat = (
  sourceId: number,
  addMessageToChatRequest: BodyType<AddMessageToChatRequest>
) => {
  return customInstance<OpenAiChatMessageView[]>({
    url: `/api/sources/openai-chat/message/${sourceId}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: addMessageToChatRequest,
  });
};

export type AddMessageToOpenAiChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof addMessageToOpenAiChat>>
>;
export type AddMessageToOpenAiChatMutationBody =
  BodyType<AddMessageToChatRequest>;
export type AddMessageToOpenAiChatMutationError = ErrorType<PlatzApiError>;

export const useAddMessageToOpenAiChat = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addMessageToOpenAiChat>>,
    TError,
    { sourceId: number; data: BodyType<AddMessageToChatRequest> },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addMessageToOpenAiChat>>,
    { sourceId: number; data: BodyType<AddMessageToChatRequest> }
  > = (props) => {
    const { sourceId, data } = props ?? {};

    return addMessageToOpenAiChat(sourceId, data);
  };

  return useMutation<
    Awaited<ReturnType<typeof addMessageToOpenAiChat>>,
    TError,
    { sourceId: number; data: BodyType<AddMessageToChatRequest> },
    TContext
  >(mutationFn, mutationOptions);
};
export const saveGoogledLyrics = (
  saveGoogledLyricsRequest: BodyType<SaveGoogledLyricsRequest>
) => {
  return customInstance<void>({
    url: `/api/sources/googled-lyrics`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: saveGoogledLyricsRequest,
  });
};

export type SaveGoogledLyricsMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveGoogledLyrics>>
>;
export type SaveGoogledLyricsMutationBody = BodyType<SaveGoogledLyricsRequest>;
export type SaveGoogledLyricsMutationError = ErrorType<PlatzApiError>;

export const useSaveGoogledLyrics = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveGoogledLyrics>>,
    TError,
    { data: BodyType<SaveGoogledLyricsRequest> },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveGoogledLyrics>>,
    { data: BodyType<SaveGoogledLyricsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return saveGoogledLyrics(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof saveGoogledLyrics>>,
    TError,
    { data: BodyType<SaveGoogledLyricsRequest> },
    TContext
  >(mutationFn, mutationOptions);
};
export const createYoutubeTranscript = (
  createYoutubeTranscriptRequest: BodyType<CreateYoutubeTranscriptRequest>
) => {
  return customInstance<CreateYoutubeSourceResponseView>({
    url: `/api/sources/create-yt-transcript/bfdsdkfjausdfbiaysbdfyabsidfybasidyfbaiysdfbaisydbfbdbhbhdbfdhbfdhfdhbfhdaeeadoycbjjkk`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: createYoutubeTranscriptRequest,
  });
};

export type CreateYoutubeTranscriptMutationResult = NonNullable<
  Awaited<ReturnType<typeof createYoutubeTranscript>>
>;
export type CreateYoutubeTranscriptMutationBody =
  BodyType<CreateYoutubeTranscriptRequest>;
export type CreateYoutubeTranscriptMutationError = ErrorType<PlatzApiError>;

export const useCreateYoutubeTranscript = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createYoutubeTranscript>>,
    TError,
    { data: BodyType<CreateYoutubeTranscriptRequest> },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createYoutubeTranscript>>,
    { data: BodyType<CreateYoutubeTranscriptRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createYoutubeTranscript(data);
  };

  return useMutation<
    Awaited<ReturnType<typeof createYoutubeTranscript>>,
    TError,
    { data: BodyType<CreateYoutubeTranscriptRequest> },
    TContext
  >(mutationFn, mutationOptions);
};
export const getAllSources = (signal?: AbortSignal) => {
  return customInstance<SourceBaseView[]>({
    url: `/api/sources`,
    method: "get",
    signal,
  });
};

export const getGetAllSourcesQueryKey = () => [`/api/sources`];

export type GetAllSourcesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllSources>>
>;
export type GetAllSourcesQueryError = ErrorType<PlatzApiError>;

export const useGetAllSources = <
  TData = Awaited<ReturnType<typeof getAllSources>>,
  TError = ErrorType<PlatzApiError>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAllSources>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllSourcesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllSources>>> = ({
    signal,
  }) => getAllSources(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getAllSources>>,
    TError,
    TData
  >({ queryKey, queryFn, ...queryOptions }) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const getYoutubePage = (
  sourceId: number,
  params?: GetYoutubePageParams,
  signal?: AbortSignal
) => {
  return customInstance<YouTubePageView>({
    url: `/api/sources/youtube-transcripts/${sourceId}`,
    method: "get",
    params,
    signal,
  });
};

export const getGetYoutubePageQueryKey = (
  sourceId: number,
  params?: GetYoutubePageParams
) => [
  `/api/sources/youtube-transcripts/${sourceId}`,
  ...(params ? [params] : []),
];

export type GetYoutubePageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getYoutubePage>>
>;
export type GetYoutubePageQueryError = ErrorType<PlatzApiError>;

export const useGetYoutubePage = <
  TData = Awaited<ReturnType<typeof getYoutubePage>>,
  TError = ErrorType<PlatzApiError>
>(
  sourceId: number,
  params?: GetYoutubePageParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getYoutubePage>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetYoutubePageQueryKey(sourceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getYoutubePage>>> = ({
    signal,
  }) => getYoutubePage(sourceId, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getYoutubePage>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!sourceId,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const getPageForTimestamp = (
  sourceId: number,
  timeStamp: number,
  signal?: AbortSignal
) => {
  return customInstance<YouTubePageView>({
    url: `/api/sources/youtube-transcript/${sourceId}/by-timestamp/${timeStamp}`,
    method: "get",
    signal,
  });
};

export const getGetPageForTimestampQueryKey = (
  sourceId: number,
  timeStamp: number
) => [`/api/sources/youtube-transcript/${sourceId}/by-timestamp/${timeStamp}`];

export type GetPageForTimestampQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPageForTimestamp>>
>;
export type GetPageForTimestampQueryError = ErrorType<PlatzApiError>;

export const useGetPageForTimestamp = <
  TData = Awaited<ReturnType<typeof getPageForTimestamp>>,
  TError = ErrorType<PlatzApiError>
>(
  sourceId: number,
  timeStamp: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPageForTimestamp>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPageForTimestampQueryKey(sourceId, timeStamp);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPageForTimestamp>>
  > = ({ signal }) => getPageForTimestamp(sourceId, timeStamp, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getPageForTimestamp>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!(sourceId && timeStamp),
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const getTextPage = (
  sourceId: number,
  params?: GetTextPageParams,
  signal?: AbortSignal
) => {
  return customInstance<TextPageView>({
    url: `/api/sources/text/${sourceId}`,
    method: "get",
    params,
    signal,
  });
};

export const getGetTextPageQueryKey = (
  sourceId: number,
  params?: GetTextPageParams
) => [`/api/sources/text/${sourceId}`, ...(params ? [params] : [])];

export type GetTextPageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTextPage>>
>;
export type GetTextPageQueryError = ErrorType<PlatzApiError>;

export const useGetTextPage = <
  TData = Awaited<ReturnType<typeof getTextPage>>,
  TError = ErrorType<PlatzApiError>
>(
  sourceId: number,
  params?: GetTextPageParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTextPage>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTextPageQueryKey(sourceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTextPage>>> = ({
    signal,
  }) => getTextPage(sourceId, params, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getTextPage>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!sourceId,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const getSourcesOfInterest = (signal?: AbortSignal) => {
  return customInstance<SourceBaseView[]>({
    url: `/api/sources/of-interest`,
    method: "get",
    signal,
  });
};

export const getGetSourcesOfInterestQueryKey = () => [
  `/api/sources/of-interest`,
];

export type GetSourcesOfInterestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSourcesOfInterest>>
>;
export type GetSourcesOfInterestQueryError = ErrorType<PlatzApiError>;

export const useGetSourcesOfInterest = <
  TData = Awaited<ReturnType<typeof getSourcesOfInterest>>,
  TError = ErrorType<PlatzApiError>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSourcesOfInterest>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSourcesOfInterestQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSourcesOfInterest>>
  > = ({ signal }) => getSourcesOfInterest(signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getSourcesOfInterest>>,
    TError,
    TData
  >({ queryKey, queryFn, ...queryOptions }) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryKey;

  return query;
};

export const getLyricsSource = (sourceId: number, signal?: AbortSignal) => {
  return customInstance<GoogledLyricsDetailsView>({
    url: `/api/sources/lyrics/${sourceId}`,
    method: "get",
    signal,
  });
};

export const getGetLyricsSourceQueryKey = (sourceId: number) => [
  `/api/sources/lyrics/${sourceId}`,
];

export type GetLyricsSourceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLyricsSource>>
>;
export type GetLyricsSourceQueryError = ErrorType<PlatzApiError>;

export const useGetLyricsSource = <
  TData = Awaited<ReturnType<typeof getLyricsSource>>,
  TError = ErrorType<PlatzApiError>
>(
  sourceId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLyricsSource>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLyricsSourceQueryKey(sourceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLyricsSource>>> = ({
    signal,
  }) => getLyricsSource(sourceId, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getLyricsSource>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!sourceId,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};

export const getChatSource = (sourceId: number, signal?: AbortSignal) => {
  return customInstance<ChatDetailsView>({
    url: `/api/sources/chats/${sourceId}`,
    method: "get",
    signal,
  });
};

export const getGetChatSourceQueryKey = (sourceId: number) => [
  `/api/sources/chats/${sourceId}`,
];

export type GetChatSourceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChatSource>>
>;
export type GetChatSourceQueryError = ErrorType<PlatzApiError>;

export const useGetChatSource = <
  TData = Awaited<ReturnType<typeof getChatSource>>,
  TError = ErrorType<PlatzApiError>
>(
  sourceId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getChatSource>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChatSourceQueryKey(sourceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatSource>>> = ({
    signal,
  }) => getChatSource(sourceId, signal);

  const query = useQuery<
    Awaited<ReturnType<typeof getChatSource>>,
    TError,
    TData
  >({
    queryKey,
    queryFn,
    enabled: !!sourceId,
    ...queryOptions,
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
};
